<div class="backoffice-companies-container">
  <div class="filter-section">
    <mat-form-field>
      <mat-label>Filtrar</mat-label>
      <input matInput (keyup)="applyFilter($event)" #input />
    </mat-form-field>
  </div>
  <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="capacity">
      <th mat-header-cell *matHeaderCellDef>capacity</th>
      <td mat-cell *matCellDef="let element">{{ element.capacity }}</td>
    </ng-container>
    <ng-container matColumnDef="coworking_group_id">
      <th mat-header-cell *matHeaderCellDef>coworking_</th>
      <td mat-cell *matCellDef="let element">
        {{ element.coworking_group_id }}
      </td>
    </ng-container>
    <ng-container matColumnDef="coworking_id">
      <th mat-header-cell *matHeaderCellDef>coworking_</th>
      <td mat-cell *matCellDef="let element">{{ element.coworking_id }}</td>
    </ng-container>
    <ng-container matColumnDef="coworking_name">
      <th mat-header-cell *matHeaderCellDef>coworking_</th>
      <td mat-cell *matCellDef="let element">{{ element.coworking_name }}</td>
    </ng-container>
    <ng-container matColumnDef="created_at">
      <th mat-header-cell *matHeaderCellDef>created_at</th>
      <td mat-cell *matCellDef="let element">
        {{ dateFormatedLong(element.created_at) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>id</th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>
    <ng-container matColumnDef="prices">
      <th mat-header-cell *matHeaderCellDef>prices</th>
      <td mat-cell *matCellDef="let element">
        <div *ngFor="let price of element.prices">
          <p>
            {{ price.title }} - {{ price.public_price }}C -
            {{ price.private_price }}â¬
          </p>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>
    <ng-container matColumnDef="state_id">
      <th mat-header-cell *matHeaderCellDef>state_id</th>
      <td mat-cell *matCellDef="let element">{{ element.state_id }}</td>
    </ng-container>
    <ng-container matColumnDef="type_id">
      <th mat-header-cell *matHeaderCellDef>type_id</th>
      <td mat-cell *matCellDef="let element">{{ element.type_id }}</td>
    </ng-container>
    <ng-container matColumnDef="updated_at">
      <th mat-header-cell *matHeaderCellDef>updated_at</th>
      <td mat-cell *matCellDef="let element">
        {{ dateFormatedLong(element.updated_at) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Acciones</th>
      <td mat-cell *matCellDef="let element">
        <div class="actions">
          <div (click)="editSpace(element)">
            <img [src]="getEditIcon" alt="" />
          </div>
          <div (click)="deleteSpace(element)">
            <img [src]="getDeleteIcon" alt="" />
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator [length]="resultsLength" [pageSize]="20"></mat-paginator>
</div>
